<template>
  <div class="page height-full">
    <app-header title="Onboarding"/>
    <b-card>
      <spinner v-if="isLoading == true" />
      <b-col v-if="account !== null" md='6' offset='3' style="padding-top: 10%;padding-bottom: 10%">
        <h2 class="text-center">Welcome to the Boom Media<br />family! 🎉</h2>
        <h4 class="text-center">Here’s a list of items that need to be completed before we can get started. </h4>
        <b-list-group>
          <b-list-group-item v-if="account.signedContract == 1" class="d-flex justify-content-between align-items-center">
            <del>Sign Contract that was sent via email</del>
            <b-badge variant="success" pill><b-icon-check/></b-badge>
          </b-list-group-item>
          <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
            Sign Contract that was sent via email
          </b-list-group-item>

          <b-list-group-item v-if="account.paidSetupFee == 1" class="d-flex justify-content-between align-items-center">
            <del>Process payment for setup fee</del>
          </b-list-group-item>
          <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
            Process payment for setup fee <a href="#" @click="checkout">here.</a>
          </b-list-group-item>

          <b-list-group-item v-if="account.invitedPartnerFacebook == 1"class="d-flex justify-content-between align-items-center">
            <del>Invite Boom Media Partner ID to your Facebook Ad Account</del>
          </b-list-group-item>
          <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
            Invite Boom Media Partner ID to your Facebook Ad Account <a href="#" @click="fbComplete">Mark as completed.</a>
          </b-list-group-item>

          <b-list-group-item v-if="account.uploadedDriveContent == 1" class="d-flex justify-content-between align-items-center">
            <del>Upload content to Google Drive</del>
          </b-list-group-item>
          <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
            Upload content to Google Drive <a href="#" @click="gDriveComplete">Mark as completed.</a>
          </b-list-group-item>

          <b-list-group-item v-if="account.invitedTeam == 1" class="d-flex justify-content-between align-items-center">
            <del>Invite your team members</del>
          </b-list-group-item>
          <b-list-group-item v-else class="d-flex justify-content-between align-items-center">
            Invite your team members <a href="#" @click="inviteTeam">Invite Team.</a>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-card>
  </div>
</template>

<script>
  import axios from "axios";
  import Constants from "../Constants";
  import Spinner from './common/Spinner'
  import * as Swal from "sweetalert2";

  export default {
    name: "Onboarding",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        isLoading: false,
        account: null,
      }
    },
    computed: {
      accountId() {
        // return this.$route.params.id
        return '6e7a63fc-8e6b-412c-980d-f03107b8565d'
      }
    },
    methods: {
      getAccount() {
        // const id = this.$route.params.id
        const id = '6e7a63fc-8e6b-412c-980d-f03107b8565d'
        this.isLoading = true
        axios.get(Constants.API_URL + '/admin/accounts/' + id)
          .then(response => {
            console.log(response)
            this.account = response.data.Items[0]
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      fbComplete() {
        const id = this.accountId
        const acct = this.account
        this.account = null
        acct.invitedPartnerFacebook = 1
        this.account = acct
        const data = {
          invitedPartnerFacebook: 1
        }
        axios.put(Constants.API_URL + '/admin/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })
      },
      gDriveComplete() {
        const id = this.accountId
        const acct = this.account
        this.account = null
        acct.uploadedDriveContent = 1
        this.account = acct
        const data = {
          uploadedDriveContent: 1
        }
        axios.put(Constants.API_URL + '/admin/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })
      },
      inviteTeam() {
        // PUT Request to mark task as completed. 
        const id = this.accountId
        const data = {
          invitedTeam: 1
        }
        axios.put(Constants.API_URL + '/admin/accounts/' + id, data)
          .then(response => {
            console.log(response)
          }).catch(err => {
            console.error(err)
          })

        // redirect to team management.
        this.$router.push('/' + id + '/users')
      },
      checkout() {
        // TODO: should get this from the URL param.. 
        const accountId = '6e7a63fc-8e6b-412c-980d-f03107b8565d'
        axios
          .get(Constants.API_URL + "/stripe/checkouts?accountId=" + accountId)
          .then(response => {
            console.log(response);
            return this.redirect(response.data.id)
          }).catch((err) => {
            swal("", err.message, "error").show()
          })
      },
      redirect(sessionId) {
        var stripe = Stripe(Constants.STRIPE_KEY);
        stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (result) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          console.log(result.error.message)
        });
      }
    },
    mounted() {
      this.getAccount()
    }
  }
</script>

<style scoped>
  .dialog-content {
    width: 100%;
    padding-right: 60px;
    padding-left: 60px;
  }

  .md-dialog-container {
    width: 50%;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  .action-container {
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Onboarding.vue